module.exports = __webpack_public_path__ + "static/media/energy.76a1d14b.png";